import React, { Component } from 'react'

import { connect } from 'react-redux'
import {
  extractFilterOptions,
  clearFilterOptionValues,
  clearInputForm,
  updateFilterOptions,
  updateFormOptions,
  checkValidity,
  updateObject,
  updateFormData,
  extractFormData
} from '../../../../helpers/utils'
import * as actions from '../../../../store/actions'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../../components/Alert/Alert'
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal'
import FilterModal from '../../../../components/FilterModal/FilterModal'
import IndividualContent from '../../../../components/PageContent/Assignment/IndividualContent/IndividualContent'
import CopyModal from '../../../../components/PageContent/Assignment/CommonContent/CopyModal/CopyModal'
import { withTranslate } from 'react-redux-multilingual'
import ImportModal from '../../../../components/ImportModal/ImportModal'
import ActionModal from '../../Appraisal/AppraisalPage/ActionModal/ActionModal'
import moment from 'moment'

// Adding/Editing in this page will not render an edit modal.
// Instead, we will render an add/edit page

class Individual extends Component {
  state = {
    appraisalTypeCode: 'APT02',
    selectedEmps: [],
    selectedResults: [],
    // Copy modal state
    copyResultId: null,
    copyModalOpen: false,
    copyForm: {
      form_id: {
        label: this.props.translate('formName'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('formName'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      level_group_id: {
        label: this.props.translate('levelGroup'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('level'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      org_id: {
        label: this.props.translate('organization'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('organization'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      position_id: {
        label: this.props.translate('position'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('position'),
          options: []
        },
        value: '',
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      emps: {
        label: this.props.translate('employee'),
        elementType: 'newmultiSelect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('employee'),
          options: []
        },
        value: [],
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      }
    },
    // Delete modal state
    deleteEmpId: null,
    confirmationModalOpen: false,
    bulkConfirmationModalOpen: false,
    // Filter modal state
    filterModalOpen: false,
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        },
        required: true
      },
      form_id: {
        label: this.props.translate('form'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('form'),
          options: []
        },
        required: true
      },
      structure_id: {
        label: this.props.translate('structure'),
        value: '',
        configs: {
          placeholder: 'Select Structure',
          options: []
        }
      },
      status_id: {
        label: this.props.translate('status'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('status'),
          options: []
        },
        required: false
      },
      // criteria_id: {
      //   label: 'Appraisal Criteria',
      //   value: '',
      //   configs: {
      //     placeholder: 'Select Criteria',
      //     options: []
      //   },
      //   loading: true,
      //   required: true
      // },
      level_group_id: {
        label: this.props.translate('levelGroup'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('level'),
          options: []
        },
        required: false
      },
      org_id: {
        label: this.props.translate('organization'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('organization'),
          options: []
        }
      },
      position_id: {
        label: this.props.translate('position'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('position'),
          options: []
        }
      },
      emp_id: {
        label: this.props.translate('employee'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('employee'),
          options: []
        }
      }
    },
    filterOptions: {
      companyFilterOptions: null,
      formFilterOptions: null,
      structureFilterOptions: null,
      // criteriaFilterOptions: null,
      orgFilterOptions: null,
      levelGroupFilterOptions: null,
      positionFilterOptions: null,
      employeeFilterOptions: null,
      statusFilterOptions: null
    },
    // Import modal state
    importModalOpen: false,
    importFile: null,
    // Action modal state
    actionModalOpen: false,
    actionForm: {
      stage_id: {
        label: this.props.translate('action'),
        elementType: 'newselect',
        elementConfig: {
          placeholder: this.props.translate('select') + this.props.translate('action'),
          options: [],
          size: 'small'
        },
        value: null,
        validation: {
          required: true
        },
        valid: false,
        touched: false,
        error: null
      },
      end_date: {
        label: this.props.translate('endDate'),
        elementType: 'datePicker',
        elementConfig: {
          size: 'small',
          inputVariant: 'outlined'
        },
        value: null,
        validation: {
          required: true
        },
        valid: true,
        touched: false,
        error: null,
        hidden: true
      },
      remark: {
        label: this.props.translate('remark'),
        elementType: 'input',
        elementConfig: {
          placeholder: this.props.translate('remark'),
          multiline: true,
          size: 'small'
        },
        value: '',
        validation: {},
        valid: true,
        touched: false,
        error: null
      }
    },
    toStageList: null,
    openFilter: false
    // currentFilter: null
  }

  componentDidMount () {
    this.props.fetchAppraisalTypes()

    const filters = this.props.filters || {}
    this.props.filterAssignmentRecords({
      ...filters,
      appraisal_type_code: this.state.appraisalTypeCode
    })
  }

  static getDerivedStateFromProps (props, state) {
    if (props.filterOptions.companyFilterOptions !== state.filterOptions.companyFilterOptions) {
      const companyFilter = state.filterControls.company_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.companyFilterOptions,
        companyFilter,
        'company_id',
        'company_id',
        { name: 'company_name', code: 'company_code' },
        'Select company'
      )

      const options = updatedFilterItem.configs?.options
      let value = options[0] || null

      updatedFilterItem = { ...updatedFilterItem, value }

      if (value && props.appraisalType) {
        const payload = {
          appraisal_type_id: props.appraisalType?.appraisal_type_id,
          company_id: value.value
        }

        props.fetchFormOptions(payload)
        props.fetchStructureOptions(payload)
        props.fetchLevelGroupOptions(payload)
        props.fetchOrgOptions(payload)
        props.fetchPositionOptions(payload)
        props.fetchEmployeeOptions(payload)
        props.fetchStatusOptions(payload)
      }

      return {
        filterControls: updateObject(state.filterControls, { company_id: updatedFilterItem }),
        filterOptions: {
          ...state.filterOptions,
          companyFilterOptions: props.filterOptions.companyFilterOptions
        }
      }
    }
    if (props.filterOptions.formFilterOptions !== state.filterOptions.formFilterOptions) {
      const formFilter = state.filterControls.form_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.formFilterOptions,
        formFilter,
        'form_id',
        'form_id',
        'form_name',
        'Select Form'
      )
      const formItem = state.copyForm.form_id
      const updatedCopyFormItem = updateFormOptions(
        props.filterOptions.formFilterOptions,
        formItem,
        'form_id',
        'form_id',
        'form_name',
        'Select Form'
      )

      const options = updatedFilterItem.configs?.options
      const value = options[0] || null

      updatedFilterItem = { ...updatedFilterItem, value }

      return {
        filterControls: updateObject(state.filterControls, { form_id: updatedFilterItem }),
        copyForm: updateObject(state.copyForm, { form_id: updatedCopyFormItem }),
        filterOptions: {
          ...state.filterOptions,
          formFilterOptions: props.filterOptions.formFilterOptions
        }
      }
    }
    if (props.filterOptions.structureFilterOptions !== state.filterOptions.structureFilterOptions) {
      const structureFilter = state.filterControls.structure_id
      const updatedFilterItem = updateFilterOptions(
        props.filterOptions.structureFilterOptions,
        structureFilter,
        'structure_id',
        'structure_id',
        'structure_name',
        'Select structure'
      )
      return {
        filterControls: updateObject(state.filterControls, { structure_id: updatedFilterItem }),
        filterOptions: {
          ...state.filterOptions,
          structureFilterOptions: props.filterOptions.structureFilterOptions
        }
      }
    }
    if (props.filterOptions.orgFilterOptions !== state.filterOptions.orgFilterOptions) {
      const orgFilter = state.filterControls.org_id
      const updatedFilterItem = updateFilterOptions(
        props.filterOptions.orgFilterOptions,
        orgFilter,
        'org_id',
        'org_id',
        { code: 'org_code', name: 'org_name' },
        'Select Organization'
      )
      const formItem = state.copyForm.org_id
      const updatedCopyFormItem = updateFormOptions(
        props.filterOptions.orgFilterOptions,
        formItem,
        'org_id',
        'org_id',
        { code: 'org_code', name: 'org_name' },
        'Select Organization'
      )
      return {
        filterControls: updateObject(state.filterControls, { org_id: updatedFilterItem }),
        copyForm: updateObject(state.copyForm, { org_id: updatedCopyFormItem }),
        filterOptions: {
          ...state.filterOptions,
          orgFilterOptions: props.filterOptions.orgFilterOptions
        }
      }
    }
    if (
      props.filterOptions.levelGroupFilterOptions !== state.filterOptions.levelGroupFilterOptions
    ) {
      const levelGroupFilter = state.filterControls.level_group_id
      const updatedFilterItem = updateFilterOptions(
        props.filterOptions.levelGroupFilterOptions,
        levelGroupFilter,
        'level_group_id',
        'level_group_id',
        'level_group_name',
        'Select level'
      )
      const formItem = state.copyForm.level_group_id
      const updatedCopyFormItem = updateFormOptions(
        props.filterOptions.levelGroupFilterOptions,
        formItem,
        'level_group_id',
        'level_group_id',
        'level_group_name',
        'Select Level'
      )
      return {
        filterControls: updateObject(state.filterControls, { level_group_id: updatedFilterItem }),
        copyForm: updateObject(state.copyForm, { level_group_id: updatedCopyFormItem }),
        filterOptions: {
          ...state.filterOptions,
          levelGroupFilterOptions: props.filterOptions.levelGroupFilterOptions
        }
      }
    }
    if (props.filterOptions.positionFilterOptions !== state.filterOptions.positionFilterOptions) {
      const positionFilter = state.filterControls.position_id
      const updatedFilterItem = updateFilterOptions(
        props.filterOptions.positionFilterOptions,
        positionFilter,
        'position_id',
        'position_id',
        { name: 'position_name', code: 'position_code' },
        'Select position'
      )
      const formItem = state.copyForm.position_id
      const updatedCopyFormItem = updateFormOptions(
        props.filterOptions.positionFilterOptions,
        formItem,
        'position_id',
        'position_id',
        'position_name',
        'Select Position'
      )
      return {
        filterControls: updateObject(state.filterControls, { position_id: updatedFilterItem }),
        copyForm: updateObject(state.copyForm, { position_id: updatedCopyFormItem }),
        filterOptions: {
          ...state.filterOptions,
          positionFilterOptions: props.filterOptions.positionFilterOptions
        }
      }
    }
    if (props.filterOptions.employeeFilterOptions !== state.filterOptions.employeeFilterOptions) {
      const employeeFilter = state.filterControls.emp_id
      const updatedFilterItem = updateFilterOptions(
        props.filterOptions.employeeFilterOptions,
        employeeFilter,
        'emp_id',
        'emp_id',
        { name: 'full_name', code: 'emp_code' },
        'Select employee'
      )
      const formItem = state.copyForm.emps
      const updatedCopyFormItem = updateFormOptions(
        props.filterOptions.employeeFilterOptions,
        formItem,
        'emp_id',
        'emp_id',
        { code: 'emp_code', name: 'full_name' },
        'Select Employee'
      )
      return {
        filterControls: updateObject(state.filterControls, { emp_id: updatedFilterItem }),
        copyForm: updateObject(state.copyForm, { emps: updatedCopyFormItem }),
        filterOptions: {
          ...state.filterOptions,
          employeeFilterOptions: props.filterOptions.employeeFilterOptions
        }
      }
    }
    if (props.filterOptions.statusFilterOptions !== state.filterOptions.statusFilterOptions) {
      const statusFilter = state.filterControls.status_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.statusFilterOptions,
        statusFilter,
        'status_id',
        'status_id',
        'status_name',
        'Select status'
      )

      const levelGroupFilter = state.filterControls.level_group_id
      const updatedLevelGroupFilterItem = {
        ...levelGroupFilter,
        required: updatedFilterItem.value?.value === 'unassigned'
      }

      return {
        filterControls: updateObject(state.filterControls, {
          status_id: updatedFilterItem,
          level_group_id: updatedLevelGroupFilterItem
        }),
        filterOptions: {
          ...state.filterOptions,
          statusFilterOptions: props.filterOptions.statusFilterOptions
        }
      }
    }
    if (props.toStageList !== state.toStageList) {
      const toStage = state.actionForm.stage_id
      let updatedFilterItem = updateFormOptions(
        props.toStageList,
        toStage,
        'stage_id',
        'stage_id',
        'status_name',
        'Select status'
      )

      return {
        ...state,
        actionForm: updateObject(state.actionForm, {
          stage_id: updatedFilterItem
        }),
        toStageList: props.toStageList
      }
    }
    return null
  }

  componentDidUpdate (prevProps) {
    if (prevProps.imported !== this.props.imported && this.props.imported) {
      this.closeImportModal()
    }
    if (prevProps.appraisalType !== this.props.appraisalType) {
      this.props.fetchFilterOptions({
        appraisal_type_id: this.props.appraisalType?.appraisal_type_id
      })
    }
    if (
      prevProps.bulkUpdateSuccess !== this.props.bulkUpdateSuccess &&
      this.props.bulkUpdateSuccess
    ) {
      this.closeActionModal(true)
    }
  }

  // Clean state
  componentWillUnmount () {
    // this.clearFilter()
    this.clearCopyForm()
    this.clearState()
    this.clearSelectedRecords()
    this.props.clearRecords()
  }

  clearFilter = () => {
    const clearedFilter = clearFilterOptionValues(this.state.filterControls)
    this.setState({
      filterControls: clearedFilter
    })
  }

  clearCopyForm = () => {
    const clearCopyForm = clearInputForm(this.state.copyForm)
    this.setState({
      copyForm: clearCopyForm
    })
  }

  clearState = () => {
    this.setState({
      copyResultId: null,
      deleteEmpId: null
    })
  }

  clearSelectedRecords = () => {
    this.setState({
      selectedEmps: [],
      selectedResults: []
    })
  }

  // records actions
  updateSelectedEmps = (empId, resultId) => {
    const selectedList = this.state.selectedEmps
    const selectedResults = this.state.selectedResults
    let updatedList = []
    let updatedResultList = []

    if (selectedList.includes(empId) || selectedResults.includes(resultId)) {
      updatedList = selectedList.filter(item => item !== empId)
      updatedResultList = selectedResults.filter(item => item !== resultId)
    } else {
      updatedList = [...selectedList, empId]
      if (resultId !== 0) {
        updatedResultList = [...selectedResults, resultId]
      }
    }

    this.setState({
      selectedEmps: updatedList,
      selectedResults: updatedResultList
    })
  }

  // Copy Modal
  openCopyModal = resultId => {
    this.setState({
      copyResultId: resultId,
      copyModalOpen: true
    })
  }

  copyInputChangedHandler = (itemKey, event) => {
    const forms = { ...this.state.copyForm }
    const targetItem = forms[itemKey]
    let value = ''

    if (['newselect', 'newmultiSelect'].includes(targetItem.elementType)) {
      value = event
    }

    const { isValid, error } = checkValidity(value, targetItem.validation, targetItem.label)

    const updatedItem = { ...targetItem, value: value, valid: isValid, error, touched: true }
    const updatedForm = updateObject(forms, { [itemKey]: updatedItem })

    this.setState({
      copyForm: updatedForm
    })
  }

  copyAssignment = () => {
    const sourceResultId = this.state.copyResultId
    const formValues = extractFilterOptions(this.state.copyForm)
    const filter = extractFilterOptions(this.state.filterControls)

    this.props.copyAssignment(
      {
        ...formValues,
        result_id: sourceResultId
      },
      filter
    )
    this.closeCopyModal(true)
  }

  closeCopyModal = submitted => {
    if (submitted) {
      this.setState({
        copyResultId: null,
        copyModalOpen: false
      })
      this.clearCopyForm()
    }
  }

  // Confirmation Modal
  openConfirmationModal = resultId => {
    this.setState({
      deleteEmpId: resultId,
      confirmationModalOpen: true
    })
  }

  deleteRecord = () => {
    const pageOptions = {
      perPage: this.props.pagination.perPage,
      page: this.props.pagination.currentPage
    }
    const filters = extractFilterOptions(this.state.filterControls, pageOptions)
    this.props.deleteAssignment(this.state.deleteEmpId, filters, 'individual')
    this.closeConfirmationModal()
  }

  closeConfirmationModal = () => {
    this.setState({
      deleteEmpId: null,
      confirmationModalOpen: false
    })
  }

  // Pagination
  pageChangeHandler = (e, page) => {
    const pageOptions = {
      perPage: this.props.pagination.perPage,
      page: page
    }
    let filters = {}

    if (this.state.openFilter) {
      filters = extractFilterOptions(this.state.filterControls, pageOptions)
    }

    this.props.filterAssignmentRecords({
      ...filters,
      appraisal_type_code: this.state.appraisalTypeCode
    })
  }

  perPageChangeHandler = perPage => {
    const pageOptions = {
      perPage: perPage,
      page: this.props.pagination.currentPage
    }
    let filters = {}

    if (this.state.openFilter) {
      filters = extractFilterOptions(this.state.filterControls, pageOptions)
    }

    this.props.filterAssignmentRecords({
      ...filters,
      appraisal_type_code: this.state.appraisalTypeCode
    })
  }

  // Filter
  openFilterModal = () => {
    this.setState({
      filterModalOpen: true,
      openFilter: true
    })
  }

  filterChangedHandler = (itemKey, event) => {
    let value = event
    const filterControls = { ...this.state.filterControls }
    const updatedItem = { ...filterControls[itemKey], value }
    let updatedFilterControls = updateObject(filterControls, { [itemKey]: updatedItem })
    const appraisalTypeId = this.props.appraisalType.appraisal_type_id
    const filterOptions = extractFilterOptions(updatedFilterControls, {
      appraisal_type_id: appraisalTypeId
    })

    if (itemKey === 'company_id') {
      this.props.fetchFormOptions(filterOptions)
      this.props.fetchStructureOptions(filterOptions)
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchOrgOptions(filterOptions)
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
      this.props.fetchStatusOptions(filterOptions)
    } else if (itemKey === 'form_id') {
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'structure_id') {
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchStatusOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'level_group_id') {
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchOrgOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'org_id') {
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'position_id') {
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'status_id') {
      this.props.fetchLevelGroupOptions(filterOptions)
      updatedFilterControls = updateObject(updatedFilterControls, {
        level_group_id: {
          ...updatedFilterControls.level_group_id,
          required: value?.value === 'unassigned'
        }
      })
    }

    this.setState({
      filterControls: updatedFilterControls
    })
  }

  closeFilterModal = filtered => {
    this.setState({
      filterModalOpen: false
    })
    if (!filtered) {
      this.clearFilter()
    } else {
      this.clearSelectedRecords()
    }
  }

  filterRecords = () => {
    const pageOptions = {
      perPage: this.props.pagination.perPage,
      page: this.props.pagination.currentPage
    }
    const filters = extractFilterOptions(this.state.filterControls, {
      ...pageOptions,
      appraisal_type_code: this.state.appraisalTypeCode
    })
    this.props.filterAssignmentRecords(filters)
    this.closeFilterModal(true)
  }

  // Assignment Actions
  startAssignment = () => {
    const selectedEmpIds = this.state.selectedEmps
    if (selectedEmpIds.length < 1) {
      this.props.fireAlert({
        message: 'Please select employees',
        options: {
          variant: 'error'
        }
      })
    } else {
      this.props.setAssignmentData({
        company_id:
          this.state.filterControls.company_id.value?.value || this.props.filters?.company_id,
        appraisal_type_id: this.props.appraisalType?.appraisal_type_id
      })
      this.props.setAssignTarget(selectedEmpIds, this.props.appraisalType)
      this.props.history.push('items')
    }
  }

  openImportModal = () => {
    this.setState({
      importModalOpen: true
    })
  }

  closeImportModal = () => {
    this.setState({
      importModalOpen: false,
      importFile: null
    })
  }

  importFileChangedHandler = event => {
    const file = event.target.files[0]
    this.setState({
      importFile: file
    })
  }

  importSubmittedHandler = () => {
    const filters = extractFilterOptions(this.state.filterControls)

    this.props.importAssignmentData(this.state.importFile, filters, this.props.appraisalType)
    // this.closeImportModal()
  }

  exportAssignmentData = () => {
    const selectedEmpIds = this.state.selectedEmps
    const filters = extractFilterOptions(this.state.filterControls)

    this.props.setAssignmentData({
      company_id: filters?.company_id || this.props.filters?.company_id || null,
      appraisal_type_id: this.props.appraisalType?.appraisal_type_id || null
    })
    this.props.setSelectAction('export')
    this.props.setAssignTarget(selectedEmpIds, this.props.appraisalType)
    this.props.history.push('items')

    // this.props.exportAssignmentData(filters)
  }

  selectAllClickedHandler = () => {
    this.setState(prevState => {
      let selectedEmps = prevState.selectedEmps
      let selectedResults = prevState.selectedResults

      if (!selectedEmps.length && !selectedResults.length) {
        selectedEmps = this.props.records
          // .filter(item => !item.structures.every(st => st.assigned))
          .map(item => item.emp_detail_id)
        selectedResults = this.props.records
          .filter(item => item.result_id)
          .map(item => item.result_id)
      } else {
        selectedEmps = []
        selectedResults = []
      }

      return {
        selectedEmps,
        selectedResults
      }
    })
  }

  bulkDeleteClickedHandler = async () => {
    this.setState({
      bulkConfirmationModalOpen: true
    })
  }

  bulkDeleteConfirmedHandler = () => {
    const { selectedResults } = this.state
    if (selectedResults.length) {
      this.props.bulkDeleteAssignment(selectedResults, 'individual')
      this.closeBulkDeleteModal()
    }
  }

  bulkDeleteCancelledHandler = () => {
    this.closeBulkDeleteModal()
  }

  closeBulkDeleteModal = () => {
    this.setState({
      bulkConfirmationModalOpen: false,
      selectedResults: [],
      selectedEmps: []
    })
  }

  actionClickedHandler = () => {
    this.setState({
      actionModalOpen: true
    })
  }

  actionInputChangedHandler = (formKey, event) => {
    const form = { ...this.state.actionForm }
    const formItem = form[formKey]

    const updatedItem = updateFormData(formItem, event)
    let updatedForm = updateObject(form, { [formKey]: updatedItem })

    if (formKey === 'stage_id') {
      const code = event?.status_code
      const endDateForm = updatedForm.end_date
      let updatedEndDateForm = {
        ...endDateForm,
        value: moment(),
        validation: { ...endDateForm.validation, required: code === 'CLS' },
        hidden: code !== 'CLS'
      }

      updatedEndDateForm = updateFormData(updatedEndDateForm, updatedEndDateForm.value)

      updatedForm = updateObject(updatedForm, { end_date: updatedEndDateForm })
    }

    this.setState({ actionForm: updatedForm })
  }

  submitActionHandler = () => {
    const actionFormData = extractFormData(this.state.actionForm)
    const requestData = {
      ...actionFormData,
      status_name: this.state.actionForm.stage_id.value?.label,
      structure_id: this.props.filters?.structure_id,
      result_id: this.state.selectedResults,
      from_page: 'assignment'
    }
    const filterOptions = extractFilterOptions(this.state.filterControls, {
      appraisal_type_code: this.state.appraisalTypeCode
    })
    this.props.bulkUpdateAssignment(requestData, filterOptions, 'individual')
  }

  closeActionModal = isCancel => {
    this.setState({
      actionModalOpen: false
    })

    if (isCancel) {
      this.clearActionForm()
    }
  }

  clearActionForm = () => {
    let cleared = clearInputForm({ ...this.state.actionForm })
    cleared = updateObject(cleared, { end_date: { ...cleared.end_date, hidden: true } })
    this.clearSelectedRecords()
    this.setState({ actionForm: cleared })
  }

  render () {
    return (
      <Aux>
        <ActionModal
          open={this.state.actionModalOpen}
          cancelled={this.closeActionModal}
          submitted={this.submitActionHandler}
          actionForm={this.state.actionForm}
          actionInputChanged={this.actionInputChangedHandler}
        />
        <ImportModal
          open={this.state.importModalOpen}
          cancelled={this.closeImportModal}
          fileChanged={this.importFileChangedHandler}
          fileSubmit={this.importSubmittedHandler}
          selectedFile={this.state.importFile}
          title={this.props.translate('assignment')}
          loading={this.props.importLoading}
        />
        <ConfirmationModal
          open={this.state.confirmationModalOpen}
          cancelled={this.closeConfirmationModal}
          confirmed={this.deleteRecord}
          promptText={this.props.translate('confirmDel')}
        />
        <ConfirmationModal
          open={this.state.bulkConfirmationModalOpen}
          cancelled={this.bulkDeleteCancelledHandler}
          confirmed={this.bulkDeleteConfirmedHandler}
          promptText={this.props.translate('confirmDel')}
        />
        <FilterModal
          open={this.state.filterModalOpen}
          cancelled={this.closeFilterModal}
          filterSaved={this.filterRecords}
          filterChanged={(itemKey, e) => this.filterChangedHandler(itemKey, e)}
          filterControls={this.state.filterControls}
          loadingQueue={this.props.filterLoadingQueue}
        />
        <CopyModal
          open={this.state.copyModalOpen}
          cancelled={this.closeCopyModal}
          copyInputChanged={(itemKey, e) => this.copyInputChangedHandler(itemKey, e)}
          copyForm={this.state.copyForm}
          copySaved={this.copyAssignment}
        />
        <Alert />
        <IndividualContent
          companyName={this.state.filterControls.company_id.value?.label}
          pagePermission={this.props.pagePermission}
          copyButtonClicked={this.openCopyModal}
          deleteButtonClicked={this.openConfirmationModal}
          empCheckboxChanged={this.updateSelectedEmps}
          assignButtonDisabled={this.props.filters?.status_id !== 'unassigned'}
          assignButtonClicked={this.startAssignment}
          empRecords={this.props.records}
          pagination={this.props.pagination}
          pageChanged={this.pageChangeHandler}
          perPageChanged={this.perPageChangeHandler}
          filterButtonClicked={this.openFilterModal}
          exportButtonDisabled={
            this.state.selectedEmps.length < 1 || this.props.filters?.status_id !== 'unassigned'
          }
          exportButtonClicked={this.exportAssignmentData}
          importButtonClicked={this.openImportModal}
          bulkDeleteButtonClicked={this.bulkDeleteClickedHandler}
          bulkDeleteButtonDisabled={
            this.state.selectedResults.length < 1 || this.props.filters?.status_id === 'unassigned'
          }
          selectedEmps={this.state.selectedEmps}
          selectedResults={this.state.selectedResults}
          selectAllClicked={this.selectAllClickedHandler}
          selectAllDisabled={!this.props.filters || !this.props.records.length}
          filtered={!!this.props.filters}
          pageLoading={this.props.pageLoading}
          filters={this.props.filters}
          actionClicked={this.actionClickedHandler}
          actionDisabled={
            !this.props.filters?.structure_id ||
            !this.props.filters?.status_id ||
            this.props.filters?.status_id === 'unassigned' ||
            !this.state.selectedResults.length
          }
        />
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  const appraisalType = state.individualAssignment.appraisalTypes.find(item => {
    return item.appraisal_type_code === 'APT02'
  })

  return {
    records: state.individualAssignment.records,
    pagination: state.individualAssignment.pagination,
    appraisalType: appraisalType,
    filtered: state.individualAssignment.filtered,
    imported: state.individualAssignment.imported,
    filters: state.assignmentFlow.filter,
    filterLoadingQueue: state.individualAssignment.filterLoadingQueue,
    pageLoading:
      state.individualAssignment.recordsLoading ||
      state.individualAssignment.appraisalTypes.length === 0,
    filterOptions: {
      companyFilterOptions: state.individualAssignment.filterCompanies,
      formFilterOptions: state.individualAssignment.filterForms,
      structureFilterOptions: state.individualAssignment.filterStructure,
      // criteriaFilterOptions: state.individualAssignment.filterCriteria,
      orgFilterOptions: state.individualAssignment.filterOrgs,
      levelGroupFilterOptions: state.individualAssignment.filterEmpLevelGroups,
      positionFilterOptions: state.individualAssignment.filterPositions,
      employeeFilterOptions: state.individualAssignment.filterEmps,
      statusFilterOptions: state.corporateAssignment.filterStatus
    },
    importLoading: state.corporateAssignment.importLoading,
    toStageList: state.individualAssignment.toStageList,
    bulkUpdateSuccess: state.individualAssignment.bulkUpdateSuccess
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchAppraisalTypes: () => {
      dispatch(actions.fetchAppraisalTypeOptions())
    },
    fetchFilterOptions: filterOptions => {
      dispatch(actions.fetchCompanyOptionsForAppraisal(filterOptions))
    },
    fetchFormOptions: filterOptions => {
      dispatch(actions.fetchFormOptions(filterOptions))
    },
    fetchStructureOptions: filterOptions => {
      dispatch(actions.fetchStructureOptionsForAppraisal(filterOptions))
    },
    fetchLevelGroupOptions: filterOptions => {
      dispatch(actions.fetchLevelGroupOptionsForAppraisal(filterOptions))
    },
    fetchOrgOptions: filterOptions => {
      dispatch(actions.fetchOrganizationOptionsForAppraisal(filterOptions))
    },
    fetchPositionOptions: filterOptions => {
      dispatch(actions.fetchPositionOptionsForAppraisal(filterOptions))
    },
    fetchEmployeeOptions: filterOptions => {
      dispatch(actions.fetchEmployeeOptionsForAppraisal(filterOptions))
    },
    fetchStatusOptions: filterOptions =>
      dispatch(actions.fetchAssignmentStatusOptionsForAppraisal(filterOptions)),
    filterAssignmentRecords: filterOptions => {
      dispatch(actions.fetchAssignmentData(filterOptions, 'individual'))
    },
    setAssignTarget: (empIds, appraisalType) => {
      dispatch(actions.setAssignTarget(empIds, appraisalType))
    },
    fireAlert: alertOption => {
      dispatch(actions.enqueueSnackbar(alertOption))
    },
    importAssignmentData: (importFile, filters, appraisalType) => {
      dispatch(actions.importAssignmentData(importFile, filters, appraisalType))
    },
    setSelectAction: action => {
      dispatch(actions.setAssignmentAction(action))
    },
    setAssignmentData: data => dispatch(actions.setAssignmentData(data)),
    deleteAssignment: (resultId, filterOptions, appraisalType) =>
      dispatch(actions.deleteAssignment(resultId, filterOptions, appraisalType)),
    copyAssignment: (data, filter) => dispatch(actions.copyAssignment(data, 'individual')),
    clearRecords: () => {
      dispatch(actions.clearFilteredAssignmentRecords())
    },
    bulkDeleteAssignment: (emps, appraisalType) =>
      dispatch(actions.bulkDeleteAssignment(emps, appraisalType)),
    bulkUpdateAssignment: (resultIds, filterOptions, appraisalType) => {
      dispatch(actions.bulkUpdateAssignment(resultIds, filterOptions, appraisalType))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(Individual))
